import { Component, OnInit, ElementRef,Renderer2, HostBinding, Inject, OnDestroy, ChangeDetectorRef, Output, EventEmitter, HostListener } from '@angular/core';
import { DOCUMENT, Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { environment } from 'src/environments/environment';
import { BusinessProfileService } from '../../../pages/business-profile/services/business-profile.service';
import { addressElements } from '../../../shared/enum/address-elements';
import { TasksService } from '../../../pages/tasks/services/tasks.service';
import { DatePipe } from '@angular/common';
import { Subscription, Subject } from 'rxjs';
import * as _ from 'lodash';
import { TaskAddModel } from './../../../pages/tasks/model/task-model';
import { CrudService } from 'src/app/services/crud.service';
import { Observable, of, from } from 'rxjs';
import { switchMap, map, takeUntil, concatMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SwitchToAnotherWorkspaceComponent } from 'src/app/Dialogs/switch-to-another-workspace/switch-to-another-workspace.component';
import { SignInService } from 'src/app/pages/sign-in/services/sign-in.service';
import { AlreadyMerchantLoginComponent } from 'src/app/Dialogs/already-merchant-login/already-merchant-login.component';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { PermissionService } from 'src/app/services/permission.service';
import { SocketService } from 'src/app/shared/socket/socketio.service';
// import { io } from 'socket.io-client'; // Removed row socket import as we use SocketService
import { ItemsService } from 'src/app/pages/items/services/items.service';
import { UploadCsvComponent } from 'src/app/shared/model-component/upload-csv/upload-csv.component';
import { SafeHtml } from '@angular/platform-browser';
import { QuoteTemplateService } from 'src/app/quote-template-new/services/quote-template.service';
import { DataService } from 'src/app/quote/quote-listing/contact-quote.service';
import { TabService } from 'src/app/quote/quote-listing/active-tab.service';
import { OrganizationViewService } from 'src/app/pages/contact-profile/view-organization/services/view-organization.service';
import { ProfileService } from 'src/app/pages/contact-profile/services/contact-profile.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { LoggerService } from 'src/app/services/logger.service';
import { NotificationUtilityService } from 'src/app/services/notification-utility.service';
import { compressBase64Image, SIGNATURE_COMPRESSION_CONFIG } from 'src/app/shared/utils/image-compression.util';
import { NotificationRow } from 'src/app/shared/models/notification.model';
import { SupportWidgetService } from 'src/app/services/support-widget.service';
import { clearAllSavedDateRanges } from 'src/app/shared/components/date-range-filter/date-range-memory';
import { sessionEmail } from 'src/app/core/session-email';
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: '/h/inicio', title: 'Inicio', icon: 'ni-tv-2 text-primary', class: '' },
];
declare var $: any;
declare var LOU: any;

@Component({
    selector: 'app-dash-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isDestroyed: boolean = false;
  notificationArr: NotificationRow[] = []
  public focus;
  isOpen: boolean;
  public userName;
  public userProfilePic;
  public userMerchants;
  public langs = ['en', 'es'];
  public imageUrl = environment.IMAGE_BACKET_URL;
  public langSelect = 'en';
  public listTitles: any[] = [];
  public location: Location;
  public merchantId;
  public currentMerchant;
  public notificationInterval;
  viewOrganizationArr:any;
  taskListDateArr: any;
  templatePayload:any;
  notifictionCount: number = 0;
  selectedContact:any;
  template_id:any;
  listingNotification: NotificationRow[] = [];
  reminderListingNotification: NotificationRow[] = [];
  reminderListingNotificationAll: NotificationRow[] = [];
  subscriptions: Subscription[] = [];
  planName:any;
  trialEndDay:any;
  profileInfo:any=''
  // LOU = LOU
  serchArr: any = {}; // hanldes the pagination and filters
  public permission;
  // private socket: any; // Removed as we use SocketService
  private loadingNotificaitons = false;
  private itemCount = 10; // items per page 

  public openDrawer = false;
  imagesNotification:any;
  customerLeadDetailsArr:any;
  public allNotifications: NotificationRow[] = [];
  quote_data: any;
  allNotificationsCount: number = 0;
  languageName:any
  private notificationAudio: HTMLAudioElement;
  private hasLoadedInitialNotificationCount = false;
  dropdownOpen = false;
  // Getter to dynamically read language from localStorage
  get currentLanguageName(): string {
    const loginUserValue = JSON.parse(localStorage.getItem('loginUserValue'));
    return loginUserValue?.languages?.name || '';
  }
  
  @Output() dataEvent = new EventEmitter<boolean>();
  progressData: { jobId: string; progress: number,name:string }[] = [];
  constructor(
    private readonly supportWidget: SupportWidgetService,
    location: Location,
    private datePipe: DatePipe,
    private element: ElementRef,
    private router: Router,
    private route: Router,
    private translate: TranslateService,
    public overlayContainer: OverlayContainer,
    private businessProfileService: BusinessProfileService,
    private TasksService: TasksService,
    @Inject(DOCUMENT) private document: Document,
    private _gService: CrudService,
    public dialog: MatDialog,
    public snackbar: MatSnackBar,
    private permissionService: PermissionService,
    private SignInService: SignInService,
    private srv :SocketService,
    private itemsService: ItemsService,
    public QuoteTemplateServices: QuoteTemplateService,
    private dataService: DataService,
    private tabService: TabService,
    private cdr: ChangeDetectorRef,
    public quoteTemplateService: QuoteTemplateService,
    private organizationservice: OrganizationViewService,
    private profileService: ProfileService,
    private translateService: TranslateService,
    private renderer: Renderer2,
    private el: ElementRef,
    private logger: LoggerService,
    public notificationUtility: NotificationUtilityService
  ) {
    this.updateLanguageName();
    this.srv.listen('jobProgress')
      .pipe(
        takeUntil(this.destroy$),
        concatMap(async (data: any) => {
          this.quote_data = data;
          if (data?.invoice_id) {
            let signatureImage = data?.signature_image;
            
            // If image is present and looks like a large base64, compress it
            if (typeof signatureImage === 'string' && signatureImage.length > SIGNATURE_COMPRESSION_CONFIG.SIZE_THRESHOLD) {
              try {
                signatureImage = await compressBase64Image(
                  signatureImage, 
                  SIGNATURE_COMPRESSION_CONFIG.MAX_WIDTH, 
                  SIGNATURE_COMPRESSION_CONFIG.MAX_HEIGHT
                );
              } catch (e) {
                this.logger.error('Error compressing signature image from socket:', e);
              }
            }

            const payload = {
              actions: data?.status,
              invoice_id: data?.invoice_id,
              merchant_id: data?.merchant_id,
              signature_image: signatureImage,
            };

            try {
              // Ensure sequential execution of status update
              await this.QuoteTemplateServices.update_quote_listing_status(payload).toPromise();
            } catch (error) {
              this.logger.error('Error updating quote listing status:', error);
            }
          }
          return data;
        })
      )
      .subscribe((data: any) => {
        // UI Updates
        const index = this.progressData.findIndex((res) => res?.jobId === data?.jobId?.id);
        this.imagesNotification = this.progressData?.length;

        if (index !== -1) {
          this.progressData[index].progress = data?.progress;
        } else if (data?.invoice_id) {
          this.notificationListing();
          this.template_id = data?.template_id;
        } else {
          this.progressData.push({
            jobId: data?.jobId?.id, 
            progress: data?.progress, 
            name: data?.jobId?.data?.selected_column
          });
        }
        this.imagesNotification = this.progressData?.length;
        this.cdr.detectChanges();
      });
    this.location = location;
    const userData = localStorage.getItem('loginUserValue') && JSON.parse(localStorage.getItem('loginUserValue'));
    translate.setDefaultLang('en');
    translate.use(userData?.languages?.locale || 'en');
    this.merchantId = localStorage.getItem('merchant_id');

    this.notificationAudio = new Audio('assets/sounds/osmos_notification.MP3');
    this.notificationAudio.preload = 'auto';
  }
  
  @HostBinding('class') componentCssClass: any;
  theme = "";
  async ngOnInit() {
    this.dataEvent.emit(false);
    this.permission = this.permissionService.retrivePermission();
    this.notificationListing();
    
    // Subscribe to language changes
    const langChangeSubs = this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateLanguageName();
    });
    this.subscriptions.push(langChangeSubs);
    this.srv.listen(localStorage.getItem('userId')+localStorage.getItem('merchant_id')).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.loadingNotificaitons = false;
      this.notificationListing();
    });

    this.userName = localStorage.getItem('fname');
    this.userProfilePic = this.imageUrl + localStorage.getItem('profile_pic');
    this.userMerchants = JSON.parse(localStorage.getItem('user_merchants') ?? 'null') ?? [];

    const getUserMerchantSubs = this.SignInService.getUserMerchant({ id: localStorage.getItem('userId'), accessId: localStorage.getItem('accessId') }).pipe(takeUntil(this.destroy$)).subscribe(result => {
      this.userMerchants = result.data.merchants
      
      if (this.merchantId) {
        this.userMerchants.forEach(merchant => {
          if (merchant.id == this.merchantId) {
            if(this.userMerchants?.profile_pic){
              merchant.profile_photo=this.userMerchants?.profile_pic
            }
            this.currentMerchant = merchant;
          }
        });
      }
    });

    this.subscriptions.push(getUserMerchantSubs);

    // Notification data is sourced from this direct TasksService.taskList() call.
    // (A previous store.select(getTasks) subscription that also called
    // setNotificationData was removed: nothing dispatches the task actions, so that
    // NgRx slice never populated and the subscription never fired.)
    const taskListSubs = this.TasksService.taskList().pipe(takeUntil(this.destroy$)).subscribe(async res => {
      this.setNotificationData(res);
    });

    this.subscriptions.push(taskListSubs)

    if (!localStorage.getItem('country_list')) {
      const countryListSubs = this.businessProfileService.countryList().pipe(takeUntil(this.destroy$)).subscribe((val: any) => {
        localStorage.setItem('country_list', JSON.stringify(val.data));
      });
      this.subscriptions.push(countryListSubs);
    }

    if (this.merchantId) {
      this.userMerchants.forEach(merchant => {
        if (merchant.id == this.merchantId) {
          if(this.userMerchants?.profile_pic){
            merchant.profile_photo=this.userMerchants?.profile_pic
          }
          this.currentMerchant = merchant;
        }
      });
    } else {
      this.currentMerchant = this.userMerchants?.[0] ?? null;
    }

    this.listTitles = ROUTES.filter(listTitle => listTitle);

    let theme = window.localStorage.getItem("theme")
    if (theme) {
      this.onSettheme(theme)
    } else {
      this.onSettheme("ligth-theme")
    }
    this.getMerchantProfile()
  }

  getStableBrowserId(): string {
    let browserId = localStorage.getItem('osmos_browserId');
    if (!browserId) {
      browserId = Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
      localStorage.setItem('osmos_browserId', browserId);
    }
    return browserId;
  }

  getStableDeviceLoginId(): string {
    let stable = localStorage.getItem('osmos_deviceLoginId_stable');
    if (!stable || stable.startsWith('U2FsdGVkX1')) {
      stable = this.getStableBrowserId();
      localStorage.setItem('osmos_deviceLoginId_stable', stable);
    }
    return stable;
  }

  async getMerchantProfile() {
    const getMerchantBusinessProfileSubs = this.businessProfileService.getMerchantBusinessProfile().pipe(takeUntil(this.destroy$)).subscribe(async (res: any) => {
      if(res.status){
        this.profileInfo=res?.data
        const plan =  res?.data?.plan_price?.plan?.name;
        const trialdateDayDif = await this.daysDif(res?.data?.trial_end_date);
        this.trialEndDay = trialdateDayDif;
        this.planName = plan;
      }
      // this.merchantProfileData = val.data;
      // this.appliedCoupons = this.merchantProfileData?.appliedCouponCode || [];
      // if(this.merchantProfileData?.plan_price?.duration == 1) {
      //   this.planPrice = this.merchantProfileData.plan_price.price;
      // } else {
      //   this.planPrice = this.merchantProfileData?.plan_price?.price * 12;
      // }
      // if (this.merchantProfileData.merchant_users) {
      //   for (let i = 0; i < this.merchantProfileData.merchant_users.length; i++) {
      //     const user = this.merchantProfileData.merchant_users[i];
      //     this.extraUsers.push({ 'email': user.email, 'roleId': user.merchant_roles[0].id, 'role_name': user.merchant_roles[0].name, 'user_id': user.id });
      //   }
      // }

      // this.addOnprice = 0;
      // if(this.merchantProfileData?.addons?.length != 0){
      //   this.addOnprice = 0;
      //   this.merchantProfileData?.addons?.forEach(addonData =>{
      //     this.addOnprice = parseFloat(this.addOnprice) + parseFloat(addonData.addon.price);
      //   });
      // }
      // this.customerCards = this.merchantProfileData?.cards;
      // this.defaultCard = this.merchantProfileData?.default_source;
      // if(this.merchantProfileData?.total_billing == 0 && redirect) {        
      //   localStorage.setItem('redirect-merchant', this.merchantProfileData?.id);
      //   localStorage.setItem('create-session', this.merchantProfileData?.id);                
      //   this.router.navigate(['/auth/sign-in'])
      // }
      // this.spinnerService.hide();
    });
    this.subscriptions.push(getMerchantBusinessProfileSubs);
  }

  async daysDif(date){
    const date1 = new Date(date);
    const date2 = new Date();
  
    const differenceInTime = date1.getTime() - date2.getTime();
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
  
    return differenceInDays;
  }
  

  openAllNotification() {
    this.openDrawer = !this.openDrawer;
  }

  closeAllNotification() {
    this.openDrawer = false;
  }

  toJSONLocal(date: Date): string {
    var local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }
// TODO: We need to optimize this code because when close drawer taking 4 to 5 second

  translateTimeago(text: string): string {
    return this.notificationUtility.translateTimeago(text);
  }

  openSideBar(){
    this.dataEvent.emit(true);  
  }
  
  notificationListing(): void {    
    if(!this.loadingNotificaitons && (localStorage.getItem('userId') || localStorage.getItem('loginUserValue'))) {
      this.loadingNotificaitons = true;
      const notificationListingSubs = this.TasksService.notificationListing({viewAll: false, hideSpinner: true}).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: { body?: { data?: { rows?: NotificationRow[], count?: number } }, data?: { rows?: NotificationRow[], count?: number } }) => {
          this.listingNotification = res.body?.data?.rows ?? res?.data?.rows ?? [];
          this.listingNotification.forEach((notification: NotificationRow) => {
            if (notification.timeago) {
              notification.timeago = this.translateTimeago(notification.timeago);
            }
          });
          const notificationCountInt = res.body?.data?.count ?? res?.data?.count ?? 0;
          if (this.hasLoadedInitialNotificationCount && notificationCountInt > this.notifictionCount) {
            this.playNotificationSound();
          }
          this.notifictionCount = notificationCountInt;
          this.hasLoadedInitialNotificationCount = true;
          this.loadingNotificaitons = false;
        },
        error: (err) => {
          this.logger.error('Error fetching notifications:', err);
          this.loadingNotificaitons = false;
        }
      });
      
      this.subscriptions.push(notificationListingSubs);
    }    
  }

  private playNotificationSound() {
    if (!this.notificationAudio) {
      return;
    }

    this.notificationAudio.currentTime = 0;
    this.notificationAudio.play().catch(() => {
      // Ignore autoplay restriction errors; user interaction will allow playback later.
    });
  }

  /**
   * Handles individual notification read events emitted by the drawer component.
   * Delegates the actual API call and routing to notificationRead to ensure
   * persistence beyond the drawer's lifecycle.
   */
  handleDrawerNotificationRead(notification: NotificationRow) {
    if (!notification || !notification.id || !notification.module) {
        this.logger.warn('Drawer: Notification read attempted with invalid data', { notification });
        return;
    }
    this.logger.info('Drawer: Notification read initiated', { id: notification.id });
    this.notificationRead(notification);
  }

  /**
   * Handles the 'Mark All as Read' event from the drawer.
   * Cleans up local notification state to keep the badge and dropdown in sync.
   */
  handleDrawerNotificationReadAll() {
    this.logger.info('Drawer: Marking all notifications as read');
    this.notifictionCount = 0;
    this.listingNotification = [];
    // The drawer component itself handles the API call to mark all as read
    this.openDrawer = false; // Close drawer after marking all as read for better UX
  }


  notificationReadAll() {
    this.TasksService.notificationRead({
      "type": "update",
      "id": "all"
    }).pipe(takeUntil(this.destroy$)).subscribe(async (res: any) => {
      this.notifictionCount = 0;
      this.listingNotification = [];
    });
  }

  /**
   * Performs the actual notification read API call and triggers navigation modules.
   * Separated to ensure it survives drawer component destruction.
   */
  notificationRead(data: NotificationRow) {
    if (!data || !data.id) return;

    // Open any embedded link in the description synchronously inside the click
    // handler. Doing this in the async subscribe callback below would be blocked
    // by popup blockers. Applies to any module whose description carries an <a>.

    const hrefMatch = data?.description?.match(/href="([^"]*)"/i);
    if (hrefMatch?.[1]) {
      window.open(hrefMatch[1], '_blank');
    }

    this.TasksService.notificationRead({
      "type": "update",
      "id": data.id
    }).pipe(takeUntil(this.destroy$)).subscribe({
      next: async (res: any) => {
          this.openDrawer = false; // Close drawer consistently when reading any notification
          if (!data.is_read) {
            if (this.notifictionCount != 0) {
              this.notifictionCount = --this.notifictionCount;
            }
          }
          data.is_read = true;
          if(data.moduleId && (data.module == 'automation' || data.module == 'task' || data.module == 'reminder')) {
            this.viewTask(data.moduleId);
          } else if(data.module == 'automation-email' ){
            // Already closed drawer, no further action for automation-email module currently
          } else {
            if (data.module == "csv_upload" || data.module == "item_csv_upload" || data.module == "quote_module" || data?.module =='eQuote_module' || data?.module =='eQuote_automation') {
              if (data.module == "quote_module" || data?.module == 'eQuote_module' || data?.module == 'eQuote_automation') {
                this.tabService.updateTab({ activeTab: 'activeQuotes' });
              }
              if(data.module == "item_csv_upload"){
                await this.getUploadedItems()
              } else if(data.module == "quote_module"){
                this.addCateogry(data?.moduleId)
              } else if (data?.module === 'eQuote_module' || data?.module === 'eQuote_automation') {
                // eQuote_automation (accept/reject automation) reuses the eQuote navigation, but
                // renders its description as-is (no "New Quote Request for" prefix, since it isn't 'eQuote_module').
                this.subscriptions.push(
                  this.QuoteTemplateServices.get_Quote_List_id(data?.moduleId)
                    .pipe(
                      switchMap((val: { data?: any }) => {
                        if (val?.data) {
                          return this.QuoteTemplateServices.merchantcustomerInfo(val.data.contact_id).pipe(
                            map((val1: any) => ({ val, val1 }))
                          );
                        }
                        return of(null);
                      }),
                      takeUntil(this.destroy$)
                    )
                    .subscribe(async (res: { val: any, val1: any } | null) => {
                      if (this.isDestroyed) return;
                      if (res && res.val1?.data) {
                        await this.addCateogryNew(res.val1.data, res.val.data);
                      }
                    })
                );
              } else {
                const locatedPath = this.location.path();
                if (locatedPath == '/dash/contacts') {
                  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                    this.router.navigate(['dash/contacts']);
                  });
                } else {
                  this.route.navigate(['/dash/contacts']);
                }
              }
            }
          }
        },
        error: (err) => {
          this.logger.error('Error reading notification:', err);
        }
      });
  }

  // For any notification whose description contains an embedded <a> link, strip
  // the anchor and trailing "Click"/"here" word so the template can render a
  // clean text + separate, real Angular-bound "Click" link.
  hasEmbeddedLink(description: string): boolean {
    return !!description && description.includes('<a');
  }

  isNewQuoteRequest(description: string): boolean {
    if (!description) return false;
    const lower = description.toLowerCase();
    if (
      lower.includes('accepted') ||
      lower.includes('quoted') ||
      lower.includes('rejected') ||
      lower.includes('quote is') ||
      lower.includes('when quote') ||
      lower.includes('order') ||
      lower.includes('invoice') ||
      lower.includes('converted') ||
      lower.includes('marked')
    ) {
      return false;
    }
    return true;
  }

  getNotificationText(description: string): string {
    if (!description) return '';
    return description
      .replace(/<a[^>]*>.*?<\/a>/i, '')
      .replace(/\b(Click|here)\b/gi, '')
      .replace(/\.\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  getImage(image) {
    if (image) {
      return this.imageUrl + image;
    }
    else {
      return 'assets/img/home/profile-logo.gif'
    }
  }
  getUploadedItems(){
    this.serchArr = {
      pagination: true,
      limit: this.itemCount,
      page: 1,
    }
    const itemSearchSubs = this.itemsService.itemSearchUploaded(this.serchArr).pipe(takeUntil(this.destroy$)).subscribe(res => {
      if(res?.data?.length){
        this.uploadItemsImages(res)
      }else{
        this.SuccessSnackBar(this.translate.instant('Your Items is not Uploaded Please Wait..'), '');
      }
    })
  }
  setNotificationData(res) {
    this.notificationArr = [];
    this.taskListDateArr = res.data['Tasks'];
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd')
    let calenderData = res.reminders ? res.reminders[today] : [];
    if (calenderData) {
      this.notificationArr = [...this.notificationArr, ...calenderData]
    }
  }
  viewTask(id) {
    // this.openAllNotification()
    localStorage.setItem('viewTaskId', id);
    this.router.navigate(['/dash/tasks/' + id + '/' + _.random(10000, 99999)]);
  }

  public onSettheme(e: string) {
    this.document.body.classList.remove(e !== 'ligth-theme' ? 'ligth-theme' : 'dark-theme');
    this.document.body.classList.add(e);
    this.componentCssClass = e;
    this.theme = this.componentCssClass
    window.localStorage.setItem("theme", e);
  }

  updateMerchant(merchant) {
    if (merchant?.id != localStorage.getItem("merchant_id")) {
        this.selectMerchant(merchant, );
    }
  }

  private selectMerchant(merchant) {
    let alreadyLoginDialogRef: any;
    const stableDeviceId = this.getStableDeviceLoginId();
    const currentRawId = this.getStableBrowserId();

    const oldMerchantId = localStorage.getItem('merchant_id');
    const oldDeviceId = localStorage.getItem('deviceLoginId');
    const userId = localStorage.getItem('userId');
    // Card #381: the workspace switch creates/removes sessions under the same email the
    // interceptor sends, or the new workspace's first request 401s. The identity (user id +
    // email) is read once and reused by every call below, so one switch can never mix two.
    const email = sessionEmail();

    if (oldMerchantId && oldMerchantId != merchant.id) {
       this._removeSession({ id: userId, email, merchant_id: oldMerchantId, device_id: oldDeviceId });
    }

    const getSessionSubs =  this.SignInService.getSession({ id: userId,email,merchant_id: merchant.id}).pipe(takeUntil(this.destroy$)).subscribe((result)=>{
      if(result && result.status !== 'error'){
        if(result.status == 'expired') { 
          localStorage.setItem('merchant_id', merchant.id);
          localStorage.setItem('osmos_access_level', merchant?.osmos_access_level);
          localStorage.setItem('role', merchant?.role);
          this.permissionService.storePermission(merchant.permission);
          this.router.navigate(['/auth2/free-trial-over']);
      } else {
        const serverRawId = result?.device_login_id ?? null;

        if (currentRawId !== serverRawId) {
          alreadyLoginDialogRef = this.dialog.open(
              AlreadyMerchantLoginComponent,
              { disableClose: true, width: '500px',height: '320px'}
          );
          alreadyLoginDialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((action: any) => {
            if (action) {
                this.currentMerchant = merchant;
                localStorage.setItem('merchant_id', merchant.id);
                localStorage.setItem('osmos_access_level', merchant.osmos_access_level);
                this.permissionService.storePermission(merchant.permission);
                const merchant_id = merchant.id;
                const id = userId;
                const device_login_id = stableDeviceId;
                const updateMerchantSubs =  this.SignInService.updateMerchant({id, device_login_id, email, merchant_id }).pipe(takeUntil(this.destroy$)).subscribe((result) => {
                  localStorage.setItem('deviceLoginId', device_login_id);
                  window.location.href = '/dash/home';
                },(error) => {
                  this.logout();
                  this.router.navigate(['/auth/sign-in']);     
                });
                this.subscriptions.push(updateMerchantSubs);
            }
          });
        } else {
          // If IDs match or no ID on server, just switch
          this.currentMerchant = merchant;
          localStorage.setItem('merchant_id', merchant.id);
          localStorage.setItem('osmos_access_level', merchant.osmos_access_level);
          this.permissionService.storePermission(merchant.permission);
          const merchant_id = merchant.id;
          const id = userId;
          const device_login_id = stableDeviceId;
          const updateMerchantSubs =  this.SignInService.updateMerchant({id, device_login_id, email, merchant_id }).pipe(takeUntil(this.destroy$)).subscribe((result) => {
            localStorage.setItem('deviceLoginId', device_login_id);
            window.location.href = '/dash/home';
          },(error) => {
            this.logout();
            this.router.navigate(['/auth/sign-in']);     
          });
          this.subscriptions.push(updateMerchantSubs);
        }
      }
    } else {
      const deviceLoginId = stableDeviceId;
      const createSessionSubs = this.SignInService.createSession({ ignore: 0, id: userId,email,merchant_id:merchant.id, device_login_id: deviceLoginId}).pipe(takeUntil(this.destroy$)).subscribe((result) => {
        if(result.status == 'expired') {
          this.currentMerchant = merchant;
          localStorage.setItem('merchant_id', merchant.id);
          localStorage.setItem('osmos_access_level', merchant.osmos_access_level);
          this.permissionService.storePermission(merchant.permission);
          this.router.navigate(['/auth2/free-trial-over']);
        } else if(result.status == 'blocked') {
          this.SuccessSnackBar(this.translate.instant('SignIn.AccountSuspended'), '');
        } else {
          this.currentMerchant = merchant;
          localStorage.setItem('deviceLoginId', deviceLoginId);
          localStorage.setItem('merchant_id', merchant.id);
          localStorage.setItem('osmos_access_level', merchant.osmos_access_level);
          this.permissionService.storePermission(merchant.permission);
          window.location.href = '/dash/home';
        }
      },(error) => {
        this.logout();
      });
      this.subscriptions.push(createSessionSubs);
    }
    });
    this.subscriptions.push(getSessionSubs);
  }

  

  _removeSession(body) {
    return this._gService.postUserManagement(`merchantuser/removeusersession`, body)
      .toPromise()
      .catch(error => { console.log(error, "error"); });
  }

  async logout(isLogout = true) {
    const payload = {
      id: localStorage.getItem('userId'),
      email: sessionEmail(), // Card #381: remove the session under the key it was created with
      merchant_id: localStorage.getItem('merchant_id'),
      device_id: localStorage.getItem('deviceLoginId')
    }
    localStorage.removeItem('merchant_id');
    localStorage.removeItem('deviceLoginId');
    // Stop receiving this workspace's live updates in this tab (logout does not reload the page).
    this.srv.resetWorkspace();
    if (isLogout) {
      localStorage.removeItem('reminderList');
      localStorage.removeItem('profile_pic');
      localStorage.removeItem('user_merchants');
      localStorage.removeItem('osmos_access_level');
      localStorage.removeItem('loginUserValue');
      // Card #269: remembered report date ranges never outlive the session.
      clearAllSavedDateRanges();
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('fname');
      localStorage.removeItem('lname');
      localStorage.removeItem('create-session');
      localStorage.removeItem('redirect-merchant');
      localStorage.removeItem('email');
      localStorage.removeItem('permission');
      localStorage.removeItem('role');
      localStorage.removeItem('accessId');
      localStorage.removeItem('country_list');
      // Quote-listing saved sort preferences
      localStorage.removeItem('quoteListingSortField');
      localStorage.removeItem('quoteListingSortOrder');
      localStorage.removeItem('quoteListingCustomSort');
      localStorage.removeItem('quoteListingSortColumn');
      // Payment-listing saved sort preference
      localStorage.removeItem('paymentListingSort');
      clearInterval(this.notificationInterval);
      await this._removeSession(payload)
      this.router.navigate(['/auth/sign-in']);
    }

  }

  getTitle() {
    let titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    return 'Inicio';
  }

  changeLang(lang) {
    this.translate.use(lang);
    this.langSelect = lang;
    this.updateLanguageName();
  }

  updateLanguageName() {
    const loginUserValue = JSON.parse(localStorage.getItem('loginUserValue'));
    this.languageName = loginUserValue?.languages?.name;
  }

  newAccount() {
    // const dialogRef = this.dialog.open(
    //     SwitchToAnotherWorkspaceComponent,
    //     { disableClose: true, width: '500px',height: '320px'}
    // );
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.logout(false);
    //     this.router.navigate(['/auth2/onboarding']);
    //   }
    // })
    this.router.navigate(['/auth2/onboarding']);
  }

  search() {
    $('.ico-header').css('display', 'none');
    $('.navbar-toggler').css('opacity', '0').css('position', 'absolute').css('z-index', '-1');
    $('.input-search-h').css('display', 'flex');
  }
  searchExit() {
    $('.ico-header').css('display', 'flex');
    $('.navbar-toggler').css('opacity', '1').css('position', 'relative').css('z-index', '0');
    $('.input-search-h').css('display', 'none');
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    if (this.destroy$) {
      this.destroy$.next(undefined);
      this.destroy$.complete();
    }
    this.openDrawer = false;
    // prevent memory leak when component destroyed
    if (this.subscriptions) {
      this.subscriptions.forEach(s => s?.unsubscribe());
    }
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
    }
  }

  otherWorkspace() {
    const dialogRef = this.dialog.open(
      SwitchToAnotherWorkspaceComponent,
      { disableClose: true, width: '500px', height: '320px' }
    );
  }

  SuccessSnackBar(msg, tag) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.horizontalPosition = 'right';
    config.duration = 3000;
    config.panelClass = 'notif-error';
    this.snackbar.open(msg, tag, config);
  }

  uploadItemsImages(data){
    const dialogRef = this.dialog.open(UploadCsvComponent, {
      width: '600px',
      maxHeight:'620px',
      data: { checkingItems: 'newImages',itemsData:data }
    });
  
    dialogRef.afterClosed().subscribe(async (result) => {
      // if (result.status) {
      //  await this.getItemList();
      // }
    });
  }

  async addCateogry(cateogryForm:any='') {
    // if (cateogryForm.form.status === 'INVALID') {
    //   this.throwError = true;
    //   return;
    // }
  
    try {
      this.tabService.updateTab({ activeTab: 'activeQuotes' });
      if(cateogryForm !==''){
        await this.getData(cateogryForm)
      }
      // Wait for businessPatchdata to complete
      // Parallelize contact and organization data fetching
      const promises = [];
      if (this.selectedContact && this.selectedContact?.id) {
        promises.push(this.contactDeal(this.selectedContact.id));
      }
      if (this.selectedContact && this.selectedContact?.merchant_organization_members?.merchant_organization?.id) {
        promises.push(this.organizationPatchdata(this.selectedContact.merchant_organization_members.merchant_organization.id));
      }
      
      await Promise.all(promises);
      
      // business: this.workSpaceData
        const data={ contact: this.selectedContact, quote:this.templatePayload?.quote_template_id?{template_id:this.templatePayload?.quote_template_id,template_style:this.templatePayload?.field_styles,quote_name:cateogryForm?.quote_name}: cateogryForm?.form?.value?.title, org: this.viewOrganizationArr ,deals:this.customerLeadDetailsArr,business:this.templatePayload?.merchantDetails};
        this.dataService.updateData(data);
        const targetUrl = `/dash/create-quote-template/${this.templatePayload?.quote_listing_id}`;
      
     
  
      await this.router.navigateByUrl('/dash/quote-listing', { skipLocationChange: true }); // Navigate to a dummy route
      await this.router.navigate([targetUrl]); // Navigate to your actual route
        // this.route.navigate(['/dash/quote-listing']);
        // this.route.navigate(['/dash/quote-listing']);
      
    } catch (error) {
      console.error('Error in addCateogry', error);
      // Handle error if needed
    }
  }

  async addCateogryNew(selectedContact, cateogryForm: any = '') {
    try {
      this.tabService.updateTab({ activeTab: 'activeQuotes' });
      const promises = [];
      if (selectedContact && selectedContact?.id) {
        promises.push(this.contactDeal(selectedContact.id));
      }
      if (selectedContact?.merchant_organization_members?.merchant_organization?.id) {
        promises.push(this.organizationPatchdata(selectedContact.merchant_organization_members.merchant_organization.id));
      }
      
      await Promise.all(promises);
  
      const data = {
        contact: selectedContact,
        quote: cateogryForm?.quote_template_id
          ? {
              template_id: cateogryForm?.quote_template_id,
              template_style: cateogryForm.field_styles,
              quote_name: cateogryForm?.quote_name,
            }
          : '',
        org: this.viewOrganizationArr,
        deals: this.customerLeadDetailsArr,
      };
  
      this.dataService.updateData(data);
  
      const targetUrl = `/dash/create-quote-template/${cateogryForm?.id}`;
      
     
  
      await this.router.navigateByUrl('/dash/quote-listing', { skipLocationChange: true }); // Navigate to a dummy route
      await this.router.navigate([targetUrl]); // Navigate to your actual route

  
    } catch (error) {
      console.error('Error in addCateogryNew:', error);
    }
  }

  contactDeal(data: any = ''): Promise<any> {
    return new Promise((resolve, reject) => {
      const merchantleadDetailSubs = this.profileService.getleadData(data).subscribe(val => {
        this.customerLeadDetailsArr = val.data;
        resolve(this.customerLeadDetailsArr);
      }, error => {
        reject(error);
      });
    });
  }
  
  organizationPatchdata(data: any = ''): Promise<any> {
    return new Promise((resolve, reject) => {
      const organizationListSubs = this.organizationservice.viewOrganization(data).subscribe(res => {
        this.viewOrganizationArr = res.data;
        resolve(this.viewOrganizationArr);
      }, error => {
        reject(error);
      });
    });
  }

  getData(id: any = ''): Promise<any> {
    return new Promise((resolve, reject) => {
      const organizationListSubs = this.QuoteTemplateServices.quote_pdf_list({invoice_id:id,merchant_id: localStorage.getItem('merchant_id'),notOpen:true}).subscribe((res: any) => {
        const decodedPayloads = JSON.parse(decodeURIComponent(escape(atob(res[0]?.payloads))));
        this.templatePayload=decodedPayloads[0]
        this.selectedContact=decodedPayloads[0]?.contactDetails
        resolve(this.selectedContact);
      }, error => {
        reject(error);
      });
    });
  
}
onOptionSelect(option: string) {
}
isDropdownOpen = false;

toggleDropdown() {
  this.isDropdownOpen = !this.isDropdownOpen;
}

onAgendaClick() {
  this.isDropdownOpen = false;
  // Implement your logic here
}

onReportsClick() {
  this.isDropdownOpen = false;
  // Implement your logic here
}
@HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const dropdown = document.querySelector('.dropdown'); // Ensure this class is set on the main div
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.isDropdownOpen = false;
    }
  }
  setMenuClass(trigger: MatMenuTrigger) {
    // wait for overlay to exist
    setTimeout(() => {
      const pane = document.querySelector('.cdk-overlay-pane');
      if (pane) {
        pane.classList.add('header-menu-pane');
      }
    });
  }
  toggleMerchantDropdown() {
    this.dropdownOpen = !this.dropdownOpen;

    if (this.dropdownOpen) {
      setTimeout(() => this.setDropdownHeight(), 0);
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (this.dropdownOpen) {
      this.setDropdownHeight();
    }
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const clickedInside = targetElement.closest('.d-inline-block.position-relative');
    if (!clickedInside && this.dropdownOpen) {
      this.dropdownOpen = false;
    }
  }

  private setDropdownHeight() {
    const dropdown = this.el.nativeElement.querySelector('.custom-dropdown');
    if (dropdown) {
      const viewportHeight = window.innerHeight; 
      const dropdownTop = dropdown.getBoundingClientRect().top;
      const maxHeight = viewportHeight - dropdownTop - 7; 
      this.renderer.setStyle(dropdown, 'max-height', `${maxHeight}px`);
      this.renderer.setStyle(dropdown, 'overflow-y', 'auto');
    }
  }
  closeDropdown() {
    this.dropdownOpen = false;
  }

  trackByNotification(index: number, item: NotificationRow): string | number {
    return item.id;
  }
  getTranslatedText(key: string): string {
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }

  translateNotificationDescription(description: string): string {
    if (!description) return '';
    return (
      this.getTranslatedText(description) ||
      this.getTranslatedText('COMMON.' + description) ||
      description
    );
  }

  getTranslatedNotificationText(description: string): string {
    const text = this.getNotificationText(description);
    if (!text) return '';
    return (
      this.getTranslatedText(text) ||
      this.getTranslatedText('COMMON.' + text) ||
      text
    );
  }

  /**
   * Opens the Support Machine widget (Lexi) in place of the old chat page.
   *
   * The widget script is async, so this can resolve false when it has not
   * arrived within the service's wait. That is the one case worth telling the
   * person about — silently doing nothing on a click is worse than a message.
   */
  openSupportChat(): void {
    this.supportWidget.open().then((reached) => {
      // The wait can outlive the component if the person navigates away.
      if (this.isDestroyed) {
        return;
      }
      if (!reached) {
        this.SuccessSnackBar(
          this.translate.instant('Snackbar.Something went wrong. Please try again.'),
          '',
        );
      }
    });
  }

}
